/* tslint:disable:no-any */
import {Pipe, PipeTransform} from '@angular/core';
import { JdOptionComponent } from './jd-option.component';
import { JdOptionGroupComponent } from './jd-option-group.component';
import {Subject} from "rxjs";

export type TFilterOption = (input?: string, option?: JdOptionComponent) => boolean;

// TODO: can not dynamic change pipe pure yet
@Pipe({ name: 'jdFilterOptionPipe' })
export class JdOptionPipe implements PipeTransform {
  constructor() {

  }
  transform(options: JdOptionComponent[], input: string, filterOption: TFilterOption, serverSearch: boolean, notSearchResult$?: Subject<{isNeedLoading: boolean, value: string}>, isLoading?: boolean): JdOptionComponent[] {
    let _options: JdOptionComponent[] = [];
    if (serverSearch && !options.length || !input || isLoading) {
      return options;
    } else {
      _options = options.filter(o => filterOption(input, o));
      /*if (_options && _options.length > pageSize) {
        return _options.slice(0, pageSize);
      }*/

      if (notSearchResult$ && !_options.length) {
        notSearchResult$.next({isNeedLoading: true, value: input});
      } else if (notSearchResult$) {
        notSearchResult$.next({isNeedLoading: false, value: input});
      }
      return _options;
    }
  }
}

@Pipe({ name: 'jdSubFilterOptionPipe' })
export class JdSubOptionPipe implements PipeTransform {
  transform(groups: JdOptionGroupComponent[], input: string, filterOption: TFilterOption, serverSearch: boolean): JdOptionGroupComponent[] {
    if (serverSearch || !input) {
      return groups;
    } else {
      return groups.filter(g => {
        return g.listOfJdOptionComponent.some(o => filterOption(input, o));
      });
    }
  }
}

export function defaultFilterOption(input: string, option: JdOptionComponent): boolean {
  if (option && option.jdLabel && option.jdValue) {
    return option.jdLabel.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
      option.jdValue.toLowerCase().indexOf(input.toLowerCase()) > -1;
  }
  return false;
}
